/* Mock auth for ENSSA Reporting Portal demo.
   Session-only sentinel in sessionStorage — no real backend.
   Any non-empty credentials succeed; SSO buttons simulate a 600ms handshake. */

export const ENSSA_AUTH_KEY = "enssa-auth";

export function isAuthed(): boolean {
  try {
    return sessionStorage.getItem(ENSSA_AUTH_KEY) === "true";
  } catch {
    return false;
  }
}

export function signIn(): void {
  try {
    sessionStorage.setItem(ENSSA_AUTH_KEY, "true");
  } catch {
    /* sessionStorage unavailable (e.g. SSR / privacy mode) — ignore */
  }
}

export function signOut(): void {
  try {
    sessionStorage.removeItem(ENSSA_AUTH_KEY);
  } catch {
    /* ignore */
  }
}
